
define('text!templates/modules/template/edit/calendar/personal-data/personal-data-details-form.html',[],function () { return '<div class="form-data-type"></div>\n<i class="type-description" data-bind="text:type_description"></i>\n<div class="urowfix">\n    <div class="ucolfix">\n         {{#t}}Unit{{/t}}: <span data-bind="text:type_unit"></span>\n    </div>\n</div>\n';});

